import { SimpleGrid, Box, Heading, Text, Icon, Flex, useColorModeValue } from '@chakra-ui/react';
import { LayoutGrid, TrendingUp, Sparkles } from 'lucide-react';

interface WinsExcitedStatsProps {
  total: number;
  wins: number;
  excited: number;
}

/**
 * Wins & Excited Statistics Cards Component
 * Displays three stat cards: Total, Wins, and Excited
 */
export function WinsExcitedStats({ total, wins, excited }: WinsExcitedStatsProps) {
  // Color mode values for dark mode support
  const cardBg = useColorModeValue('white', 'gray.700');
  const labelColor = useColorModeValue('gray.600', 'gray.400');
  const headingColor = useColorModeValue('gray.900', 'white');
  const iconBgGray = useColorModeValue('gray.100', 'gray.600');
  const iconColorGray = useColorModeValue('gray.600', 'gray.300');
  const iconBgGreen = useColorModeValue('green.100', 'green.900');
  const iconBgPurple = useColorModeValue('purple.100', 'purple.900');

  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
      {/* Total Card */}
      <Box
        borderWidth="1px"
        borderRadius="lg"
        shadow="sm"
        p={6}
        bg={cardBg}
      >
        <Flex justify="space-between" align="center">
          <Box>
            <Text fontSize="sm" color={labelColor} mb={1}>
              Total Entries
            </Text>
            <Heading size="lg" color={headingColor}>
              {total}
            </Heading>
          </Box>
          <Box
            p={3}
            bg={iconBgGray}
            borderRadius="full"
          >
            <Icon as={LayoutGrid} w={6} h={6} color={iconColorGray} />
          </Box>
        </Flex>
      </Box>

      {/* Wins Card */}
      <Box
        borderWidth="1px"
        borderRadius="lg"
        shadow="sm"
        p={6}
        bg={cardBg}
      >
        <Flex justify="space-between" align="center">
          <Box>
            <Text fontSize="sm" color={labelColor} mb={1}>
              Wins
            </Text>
            <Heading size="lg" color={headingColor}>
              {wins}
            </Heading>
          </Box>
          <Box
            p={3}
            bg={iconBgGreen}
            borderRadius="full"
          >
            <Icon as={TrendingUp} w={6} h={6} color="green.500" />
          </Box>
        </Flex>
      </Box>

      {/* Excited Card */}
      <Box
        borderWidth="1px"
        borderRadius="lg"
        shadow="sm"
        p={6}
        bg={cardBg}
      >
        <Flex justify="space-between" align="center">
          <Box>
            <Text fontSize="sm" color={labelColor} mb={1}>
              Excited About
            </Text>
            <Heading size="lg" color={headingColor}>
              {excited}
            </Heading>
          </Box>
          <Box
            p={3}
            bg={iconBgPurple}
            borderRadius="full"
          >
            <Icon as={Sparkles} w={6} h={6} color="purple.500" />
          </Box>
        </Flex>
      </Box>
    </SimpleGrid>
  );
}

